.fp-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 20px;
  background: var(--color-bg);
}

.fp-main {
  padding-top: 80px; /* offset for navbar */
  background: var(--color-bg);
}

.fp-hero {
  padding: 100px 0 80px;
  text-align: center;
  background: linear-gradient(180deg, #F8FAFC 0%, #FFFFFF 100%);
  position: relative;
}

.fp-icon-wrap {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  background: var(--gradient-accent);
  color: #fff;
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 32px;
  box-shadow: 0 12px 32px rgba(99,91,255,0.25);
  animation: float 4s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.fp-hero h1 {
  font-family: var(--font-heading);
  font-size: clamp(36px, 5vw, 56px);
  font-weight: 800;
  color: var(--color-text-primary);
  margin-bottom: 16px;
}

.fp-subtitle {
  font-size: 22px;
  font-weight: 600;
  color: var(--color-accent);
  margin-bottom: 24px;
}

.fp-desc {
  font-size: 18px;
  color: var(--color-text-secondary);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.7;
}

.fp-importance-section {
  padding: 60px 0 20px;
  background: var(--color-bg);
}

.fp-importance-card {
  background: #fff;
  border-radius: 24px;
  padding: 48px;
  text-align: center;
  box-shadow: 0 4px 24px rgba(0,0,0,0.04);
  border: 1px solid var(--color-border);
  max-width: 900px;
  margin: 0 auto;
}

.fp-importance-card h2 {
  font-family: var(--font-heading);
  font-size: 28px;
  font-weight: 800;
  color: var(--color-text-primary);
  margin-bottom: 20px;
}

.fp-importance-card p {
  font-size: 18px;
  color: var(--color-text-secondary);
  line-height: 1.7;
}

.fp-steps-section {
  padding: 80px 0 120px;
  background: #fff;
}

.fp-section-title {
  text-align: center;
  font-family: var(--font-heading);
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 64px;
}

.fp-steps-list {
  display: flex;
  flex-direction: column;
  gap: 80px;
}

.fp-step-card {
  display: flex;
  align-items: center;
  gap: 60px;
}

/* Alternate rows */
.fp-step-card:nth-child(even) {
  flex-direction: row-reverse;
}

.fp-step-content {
  flex: 1;
}

.fp-step-number {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(99,91,255,0.1);
  color: var(--color-accent);
  font-family: var(--font-heading);
  font-size: 20px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.fp-step-content h3 {
  font-family: var(--font-heading);
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: 16px;
}

.fp-step-content p {
  font-size: 16px;
  color: var(--color-text-secondary);
  line-height: 1.7;
}

.fp-step-image {
  flex: 1.2;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0,0,0,0.08);
  border: 1px solid rgba(0,0,0,0.05);
  background: #f1f5f9;
  aspect-ratio: 16/9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fp-step-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s var(--ease-spring);
}

.fp-step-card:hover .fp-step-image img {
  transform: scale(1.02);
}

@media (max-width: 768px) {
  .fp-step-card,
  .fp-step-card:nth-child(even) {
    flex-direction: column;
    gap: 32px;
  }
}
